/* Maeve & Co — Size guide modal (self-contained, body-level) */
(function () {
  'use strict';
  var overlay = null;

  function build() {
    var tpl = document.querySelector('[data-maeve-sg-template]');
    if (!tpl || !tpl.content) return null;
    var el = document.createElement('div');
    el.className = 'maeve-sg__overlay';
    var backdrop = document.createElement('div');
    backdrop.className = 'maeve-sg__backdrop';
    backdrop.addEventListener('click', close);
    el.appendChild(backdrop);
    el.appendChild(tpl.content.cloneNode(true));
    el.querySelectorAll('[data-maeve-sg-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.body.appendChild(el);
    return el;
  }

  function open(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    if (!overlay) overlay = build();
    if (!overlay) return;
    overlay.classList.add('is-open');
    document.documentElement.classList.add('maeve-sg-lock');
    document.body.classList.add('maeve-sg-lock');
  }

  function close(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('maeve-sg-lock');
    document.body.classList.remove('maeve-sg-lock');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-maeve-sg-open]') : null;
    if (trigger) open(e);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) close(e);
  });
})();
